import React from 'react';
import PropTypes from 'prop-types';

function ProgressBar({
  progressNumbers,
  onMouseOver,
  onMouseOut,
  onMouseMove,
  routeId,
  isLoading
}) {
  const {
    progressDelivered,
    progressUndelivered,
    progressRedelivered,
    progressCanceled,
    progressPartial
  } = progressNumbers;

  if (isLoading) {
    return <span data-testid="loading" className="loading-progress" />;
  }

  return (
    <button
      data-testid={`progress-bar-route-${routeId}`}
      className="routeMonitorProgressBarContainer"
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onMouseMove={onMouseMove}
      type="button"
    >
      <div
        data-testid={`progressDelivered-route-${routeId}`}
        className="progressDelivered"
        style={{ width: progressDelivered }}
      />
      <div
        data-testid={`progressPartial-route-${routeId}`}
        className="progressPartial"
        style={{ width: progressPartial }}
      />
      <div
        data-testid={`progressUndelivered-route-${routeId}`}
        className="progressUndelivered"
        style={{ width: progressUndelivered }}
      />
      <div
        data-testid={`progressRedelivered-route-${routeId}`}
        className="progressRedelivered"
        style={{ width: progressRedelivered }}
      />
      <div
        data-testid={`progressCanceled-route-${routeId}`}
        className="progressCanceled"
        style={{ width: progressCanceled }}
      />
    </button>
  );
}

ProgressBar.propTypes = {
  progressNumbers: PropTypes.object.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  onMouseMove: PropTypes.func.isRequired,
  routeId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool
};

ProgressBar.defaultProps = {
  isLoading: false
};

export default ProgressBar;
